import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import contactimg from '../images/contactus/contactus.png';
import logo from '../images/contactus/logo.png'
import NavbarMob from '../components/NavbarMob';
import Navbar from '../components/Navbar';
import FooterMob from '../components/FooterMob';
import Footer from '../components/Footer';
import axios from 'axios'
import { toast } from 'react-toastify';

function Contact() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiRazorpayUrl = process.env.REACT_APP_API_SERVER_URL;
    const apiWhatsappUrl = process.env.REACT_APP_API_WHATSAPP;


    const [loading, setLoading] = useState(false);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobileNumber: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };


    const handleSendToWhatsApp = async () => {
        const { name, email, mobileNumber, message } = formData;

        // Validate inputs
        if (!name || !email || !mobileNumber || !message) {
            toast.info('Please fill out all fields.');
            return;
        }

        const normalizeMobile = (num) => {
            if (!num) return "";

            // Convert to string & trim spaces
            num = String(num).trim();

            // Remove all non-digits (if any)
            num = num.replace(/\D/g, "");

            // If number starts with 0 ? remove that 0
            if (num.startsWith("0")) {
                num = num.substring(1);
            }

            // Now ensure it starts with 91
            if (!num.startsWith("91")) {
                num = "91" + num;
            }

            return num;
        };

        const finalMobile = normalizeMobile(mobileNumber); 

        setLoading(true); // Start loading

        // Prepare data for WhatsApp API
        const formattedMessage = `Name: ${name}\nNumber: ${mobileNumber}\nEmail: ${email}\nMessage: ${message}`;

        try {
            // const response = await fetch(`${apiRazorpayUrl}/send-whatsapp`, {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify({ to, message: formattedMessage })
            // });

            const response = await axios.post(`${apiWhatsappUrl}/send-message`, {
                // userId: 'BLACKBATON',
                appkey: "98efaeca-73f7-4340-8745-1647982a0ba8",
                authkey: "10b2f32068003fd32a0878f57a8a0b2e",
                to: finalMobile,
                message: formattedMessage
            });

            const data = await response.json();
            if (data.success) {
                toast.info('Message sent successfully to WhatsApp!');
                setFormData({
                    name: '',
                    email: '',
                    mobileNumber: '',
                    message: ''
                });
            } else {
                toast.info('Message sent successfully');
                setFormData({
                    name: '',
                    email: '',
                    mobileNumber: '',
                    message: ''
                });
            }

        } catch (error) {
            console.error('Error sending WhatsApp message:', error);
            toast.info('An error occurred while sending the message. Please try again.');
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div className='min-h-screen flex flex-col'>
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className='w-full flex flex-row lg:mt-[175px] md:mt-[175px] mt-[60px]'>
                <div className='w-[50%] h-full lg:flex hidden'>
                    <img src={contactimg} alt="contactimg" className='w-full h-full ' />
                </div>
                <div className='lg:w-[50%] w-full h-auto flex justify-center items-center lg:p-0 p-7'>
                    <div className='flex flex-col gap-8  text-left   '>
                        <img src={logo} alt="logo" className='w-[30%] h-[30%]' />
                        <div className='flex flex-col gap-3'>
                            <span className='lg:text-4xl text-2xl font-[700] font-montserrat'>Let�s Get In Touch</span>
                            <span className='text-base font-[400] text-[#989898] font-montserrat'>Or just reach out manually to <span className='lg:text-base text-sm font-[600] text-[black] font-montserrat'>Info.stillsclothing@gmail.com</span></span>
                        </div>
                        <div className='flex flex-col gap-5 w-full '>
                            <div className='flex flex-row justify-between gap-3'>
                                <div className='flex flex-col gap-2 text-left w-full'>
                                    <span className='text-[#888888] font-[400] font-montserrat text-sm'>Full Name</span>
                                    <input type="text" className='rounded-[23px] w-full h-[46px] border-2 border-[#E0E0E0] p-4' name='name' value={formData.name} onChange={handleChange} />
                                </div>

                            </div>

                            <div className='flex flex-row justify-between gap-3'>
                                <div className='flex flex-col gap-2 text-left w-full'>
                                    <span className='text-[#888888] font-[400] font-montserrat text-sm'>Email Address</span>
                                    <input type="text" className='rounded-[23px] w-full h-[46px] border-2 border-[#E0E0E0] p-4' name='email' value={formData.email} onChange={handleChange} />
                                </div>

                            </div>

                            <div className='flex flex-row justify-between gap-3'>
                                <div className='flex flex-col gap-2 text-left w-full'>
                                    <span className='text-[#888888] font-[400] font-montserrat text-sm'>Phone Number</span>
                                    <input type="text" className='rounded-[23px] w-full h-[46px] border-2 border-[#E0E0E0] p-4' name='mobileNumber' value={formData.mobileNumber} onChange={handleChange} />
                                </div>

                            </div>

                            <div className='flex flex-row justify-between gap-3'>
                                <div className='flex flex-col gap-2 text-left w-full'>
                                    <span className='text-[#888888] font-[400] font-montserrat text-sm'>Message</span>
                                    <textarea className='rounded-[23px] w-full h-[136px] border-2 border-[#E0E0E0] p-4 text-left align-top' name='message' value={formData.message} onChange={handleChange} />
                                </div>

                            </div>
                        </div>

                        <div className='w-full flex justify-center items-center'>
                            <button
                                className='w-full h-[46px] rounded-[23px] bg-black flex justify-center items-center text-white text-sm font-[600] font-montserrat cursor-pointer disabled:opacity-50'
                                onClick={handleSendToWhatsApp}
                                disabled={loading}
                            >
                                {loading ? 'Submitting...' : 'Submit Form'}
                            </button>
                        </div>


                    </div>
                </div>

            </div>
            {isTab ? <FooterMob /> : <Footer />}
        </div>

    );
}

export default Contact;




